<template>
    
    <div class="custom-box-container">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "CustomBox"
    };
</script>

<style lang="scss" scoped>

    .custom-box-container {
        border: 1.5px solid #467AB5;
        margin: 1rem;
    }

    .custom-box-container::before {
        background-image: url(../assets/images/search/border-bottom.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;
        content: "";
        width: 101%;
        left: -0.5%;
        height: 1rem;
        display: inline-block;
        position: relative;
        top: -0.1rem;
        transform: rotate(180deg);
    }

    .custom-box-container::after {
        background-image: url(../assets/images/search/border-bottom.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;
        content: "";
        width: 101%;
        left: -0.5%;
        height: 1rem;
        display: inline-block;
        position: relative;
        top: 0.4rem;
    }
</style>